import script from "./HomepageTechnopolis.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageTechnopolis.vue?vue&type=script&setup=true&lang=js"

import "./HomepageTechnopolis.vue?vue&type=style&index=0&id=e0bc9888&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0bc9888"]])

export default __exports__